import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { font } from '../../styles';
import { styled } from '../../utils';
import { Icon } from '../Icon';
//TODO: Maybe replace with mui avatar?
export function Avatar(props) {
    const bgImage = props.img
        ? {
            style: {
                backgroundImage: `url(${props.img})`,
            },
        }
        : {};
    return (_jsxs(AvatarStyled, { img: props.img, size: props.size, title: props.title, ...bgImage, onClick: props.onClick, children: [props.initials && props.initials, !props.initials && props.icon && (_jsx(IconStyled, { variant: props.icon, size: props.size }))] }));
}
const avatarSizeVariants = (theme, size) => {
    const sizes = {
        s: {
            width: '32px',
            height: '32px',
            borderRadius: '16px',
            fontSize: font.size.s,
        },
        m: {
            width: '40px',
            height: '40px',
            borderRadius: '24px',
            fontSize: font.size.m,
            fontWeight: theme.typography.fontWeightRegular,
        },
        l: {
            width: '60px',
            height: '60px',
            borderRadius: '30px',
            fontSize: '2.25rem',
        },
        xl: {
            width: '76px',
            height: '76px',
            borderRadius: '38px',
            fontSize: '3.25rem',
        },
    };
    return sizes[size];
};
const AvatarStyled = styled('div', {
    shouldForwardProp: (prop) => prop !== 'img' && prop !== 'size',
})(({ theme, img, size }) => ({
    backgroundColor: theme.palette.secondary.lighter,
    backgroundSize: img ? 'cover' : 'unset',
    backgroundPosition: img ? 'center' : 'unset',
    color: theme.palette.primary.dark,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...avatarSizeVariants(theme, size),
}));
const IconStyled = styled(Icon)(({ theme, size }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...avatarSizeVariants(theme, size),
}));
